import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { requiredTranslatableZodSchema } from "@@/shared/translations/translation";
import { generateId } from "@@/utilities/generate-id";
import { z } from "zod";
import { discountConditionZodSchema } from "../../conditions/discount-condition";
import { discountCodeBulkIdZodSchema } from "../discount-code-bulk-id";
import { discountCodeZodString } from "../discount-code-string";
import { discountCodeUsageLimitZodObject } from "../discount-code-usage-limits";

const discountCodeBulkEditCommandZodObject = z.object({
    _id: idZodSchema.default(() =>
        generateId({ prefix: "discount_code_bulk_edit_command__" }),
    ),
    _type: z
        .literal("DISCOUNT_CODE_BULK_EDIT_COMMAND")
        .default("DISCOUNT_CODE_BULK_EDIT_COMMAND"),
    _createdAt: isoAndUnixZodSchema.default(() => nowIsoAndUnix()),
    providerId: providerIdZodSchema,
    title: requiredTranslatableZodSchema,
    conditions: z.array(discountConditionZodSchema),
    value: z.number().min(0),
    type: z.enum(["PERCENTAGE", "VALUE"]),
    usage: discountCodeUsageLimitZodObject,
    start: isoAndUnixZodSchema,
    end: isoAndUnixZodSchema,
    /** Prefix every generated code with this string */
    codePrefix: discountCodeZodString,
    /** Number of codes to generate */
    count: z.number(),
    bulkId: discountCodeBulkIdZodSchema,
});

type DiscountCodeBulkEditCommand = z.infer<
    typeof discountCodeBulkEditCommandZodObject
>;

const discountCodeBulkEditCommandFactoryParamsZodObject =
    discountCodeBulkEditCommandZodObject.omit({
        _id: true,
        _type: true,
        _createdAt: true,
    });
type FactoryParams = z.infer<
    typeof discountCodeBulkEditCommandFactoryParamsZodObject
>;

const discountCodeBulkEditCommandFactory = (
    params: FactoryParams,
): DiscountCodeBulkEditCommand => {
    return discountCodeBulkEditCommandZodObject.parse(params);
};
export {
    discountCodeBulkEditCommandFactory,
    discountCodeBulkEditCommandFactoryParamsZodObject,
    discountCodeBulkEditCommandZodObject,
};
export type {
    DiscountCodeBulkEditCommand,
    FactoryParams as DiscountCodeBulkEditCommandFactoryParams,
};
